import type { ReactElement } from 'react';
import { DONUT_SIZE, DONUT_TRACK_WIDTH } from './piechart-constants';
import { PieChartArcLayers } from './PieChartArcLayers';
import { PieChartCenterLabel } from './PieChartCenterLabel';
import { PieChartSvgDefs } from './PieChartSvgDefs';
import type { PieChartHoverChange, PieChartRenderModel } from './piechart-types';
interface PieChartSvgProps {
    renderModel: PieChartRenderModel;
    hoveredIndex: number | null;
    onHoveredIndexChange: PieChartHoverChange;
    pieChartIdPrefix: string;
}
export function PieChartSvg({ renderModel, hoveredIndex, onHoveredIndexChange, pieChartIdPrefix, }: PieChartSvgProps): ReactElement {
    return (
      <svg width={DONUT_SIZE} height={DONUT_SIZE} viewBox={`${-renderModel.glowPad} ${-renderModel.glowPad} ${renderModel.viewSize} ${renderModel.viewSize}`} style={{ flexShrink: 0, overflow: 'visible' }}>
        <PieChartSvgDefs arcs={renderModel.arcs} pieChartIdPrefix={pieChartIdPrefix}/>

      <circle cx={renderModel.centerX} cy={renderModel.centerY} r={renderModel.radius} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={DONUT_TRACK_WIDTH}/>

      <PieChartArcLayers arcs={renderModel.arcs} centerX={renderModel.centerX} centerY={renderModel.centerY} hoveredIndex={hoveredIndex} onHoveredIndexChange={onHoveredIndexChange} pieChartIdPrefix={pieChartIdPrefix}/>

        <PieChartCenterLabel arcs={renderModel.arcs} centerX={renderModel.centerX} hoveredIndex={hoveredIndex} radius={renderModel.radius}/>
      </svg>
    );
}
